import { Component, Input, OnInit, HostListener } from "@angular/core";
import { OnlineApplicationRequestPayload } from "../../../@core/models/RequestPayloads/OnlineApplicationRequestPayload";
import { NbDialogRef } from "@nebular/theme";

@Component({
  selector: "uc-view-summary",
  templateUrl: "./uc-view-summary.component.html",
  styleUrls: ["./uc-view-summary.component.scss"],
})
export class UcViewSummaryComponent implements OnInit {
  constructor() {}

  private _oaReqPayload: OnlineApplicationRequestPayload;
  @Input("oaReqPayload")
  public get oaReqPayload(): OnlineApplicationRequestPayload {
    return this._oaReqPayload;
  }
  public set oaReqPayload(v: OnlineApplicationRequestPayload) {
    this._oaReqPayload = v;
  }

  private _activeModal: NbDialogRef<UcViewSummaryComponent>;
  @Input("activeModal")
  public get activeModal(): NbDialogRef<UcViewSummaryComponent> {
    return this._activeModal;
  }
  public set activeModal(v: NbDialogRef<UcViewSummaryComponent>) {
    this._activeModal = v;
  }

  //"Escape" tuşuna bastığımızı yakalayıp hata almadan modalı kapatıyoruz
  @HostListener("window:keyup", ["$event"]) keyEvent(event: KeyboardEvent) {
    if (event.key == "Escape") {
      this.closeModal();
    }
  }

  ngOnInit() {}

  ngAfterViewInit() {}

  closeModal() {
    this.activeModal.close();
  }
}
